module.exports = __webpack_public_path__ + "assets/Generic.5477dcc7.svg";